import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPage from "@/components/DashboardPage.vue";
import CategoryPage from "@/components/CategoryPage.vue";
import DetailPage from "@/components/DetailPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: DashboardPage,
  },
  {
    path: "/callback",
    name: "authCallback",
    component: DashboardPage,
  },
  {
    path: "/:category",
    name: "category",
    component: CategoryPage,
  },
  {
    path: "/:category/:uid",
    name: "detail",
    component: DetailPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
